

// src/api.js

const BASE_URL = 'https://v3.dhundhoo.com';

export const API = {
    // User-related endpoints
    login: `${BASE_URL}/auth/signin`,
    authorize: `${BASE_URL}/auth/authorize`,


    // Add more as needed
};
